import { helper } from '@ember/component/helper';
import { JourneyMetricsMeasure } from 'cio/utils/journey-metrics';
import { Measure } from 'cio/utils/metrics/common';
import { MeasureType, MEASURE_DEFINITIONS } from 'cio/utils/metrics/measure';

export function measureLabel([measure, measureType, valueLabel]: [Measure, MeasureType.DeliveryMetrics, boolean?]):
  | string
  | null;
export function measureLabel([measure, measureType, valueLabel]: [
  JourneyMetricsMeasure,
  MeasureType.JourneyMetrics,
  boolean?,
]): string | null;
export function measureLabel([measure, measureType, valueLabel]: [
  Measure | JourneyMetricsMeasure,
  MeasureType,
  boolean?,
]): string | null {
  if (valueLabel == null) {
    valueLabel = false;
  }
  if (measureType == null) {
    measureType = MeasureType.DeliveryMetrics;
  }
  let definition = MEASURE_DEFINITIONS[measureType]?.[measure];

  if (definition == null) {
    return null;
  }

  if (valueLabel && definition.valueLabel != null) {
    return definition.valueLabel;
  }

  return definition.label;
}

export default helper(measureLabel);
